import type { CalendarAppointment } from './types';

/** Non-canceled and dated before today: a neutral fact (no "completed"
 *  status exists), not an alarm — must not read as missed/overdue. */
export function isPastAppointment(appointment: CalendarAppointment, todayIso: string): boolean {
    return appointment.canceledAt === null && appointment.date < todayIso;
}

/** Past, non-canceled, no linked chart note: the one signal worth an amber
 *  "Add chart note" nudge rather than an error treatment. */
export function needsChartNote(appointment: CalendarAppointment, todayIso: string): boolean {
    return isPastAppointment(appointment, todayIso) && !appointment.hasNote;
}

export function isNotCanceled(appointment: CalendarAppointment): boolean {
    return appointment.canceledAt === null;
}

/** date-only ('YYYY-MM-DD') -> appointment count. Shared by the left-rail
 *  calendar and a Date field's popover so both show the same count dots. */
export function countAppointmentsByDate(
    appointments: readonly CalendarAppointment[]
): Record<string, number> {
    const counts: Record<string, number> = {};
    appointments.forEach((appointment) => {
        counts[appointment.date] = (counts[appointment.date] || 0) + 1;
    });
    return counts;
}
